<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="card">
          <div class="card-header">
            Detalhes
            <span class="span-is-link span-color-link ml-3">
              <!-- Editar -->
              <i v-if="canChangeCustomer" class="fa fa-pencil-square-o" @click="editItem()"></i>
              <!-- Deletar -->
              <i v-if="canDeleteCustomer" class="fa fa-trash trash-color ml-3" @click="deleteItem()"></i>
            </span>
            <span v-if="user.online" class="badge badge-warning ml-2">
              <i class="fa fa-wifi"></i> online
            </span>
          </div>
          <div class="card-body">
            <div class="row">
              <b-col lg=4>
                <!-- Card detalhes -->
                <b-card :title="user.name" no-body>
                  <div v-if="$store.getters['auth/isAdmin']" class="table-perm">
                      <div class="row">
                        <div class="col-4">
                          <div class="text-center">CRM</div>
                          <div class="crud">
                          <span class="l-spacing">CRUD</span><br>
                            <span>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'add_customer') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'view_customer') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'change_customer') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'delete_customer') ? 'fa-check ok' : 'fa-minus no'"></i>
                            </span>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="text-center">Financeiro</div>
                          <div class="crud">
                            <span class="l-spacing">CRUD</span><br>
                            <span>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'add_expense') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'view_expense') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'change_expense') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'delete_expense') ? 'fa-check ok' : 'fa-minus no'"></i>
                            </span>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="text-center">Contrato</div>
                          <div class="crud">
                            <span class="l-spacing">CRUD</span><br>
                            <span>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'add_contract') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'view_contract') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'change_contract') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'delete_contract') ? 'fa-check ok' : 'fa-minus no'"></i>
                            </span>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="text-center">Timesheet</div>
                          <div class="crud">
                            <span class="l-spacing">CRUD</span><br>
                            <span>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'add_timesheet') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'view_timesheet') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'change_timesheet') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'delete_timesheet') ? 'fa-check ok' : 'fa-minus no'"></i>
                            </span>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="text-center">Pastas</div>
                          <div class="crud">
                            <span class="l-spacing">CRUD</span><br>
                            <span>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'add_folder') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'view_folder') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'change_folder') ? 'fa-check ok' : 'fa-minus no'"></i>
                              <i class="fa p-right" :class="user.permissions.permissions.find(c => c.codename == 'delete_folder') ? 'fa-check ok' : 'fa-minus no'"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                  </div>
                  <b-card-body>
                    <b-card-title>{{ user.name }}</b-card-title>
                    <b-link href="" class="card-link"><i class="fa fa-envelope-o"></i> {{ user.email }}</b-link>
                    <br>
                    <b-link v-if="user.personal_email" href="" class="card-link"><i class="fa fa-user-o"></i> {{ user.personal_email }}</b-link>
                    <br>
                    <img :src="user.photo" alt="" width="130px">
                  </b-card-body>
                  <b-list-group flush>
                    <b-list-group-item v-if="$store.getters['auth/isAdmin']">
                      RG: <span v-if="user.rg">{{ user.rg | VMask('##.###.###-#') }}</span> <br>
                      CPF: <span v-if="user.cpf">{{ user.cpf | VMask('###.###.###-##') }}</span> <br>
                      CNH: {{ user.cnh }} <br>
                      OAB: {{ user.oab }} <br>
                      OAB UF: {{ user.oab_uf }} <br>
                      Nascimento: <span v-if="$store.getters['auth/isAdmin']">{{ user.birthday | formatDate }}</span>
                    </b-list-group-item>
                    <b-list-group-item>
                      <span class="float-right">Depto: {{ occupation.department_display }}</span>
                      Cargo: {{ occupation.text }}
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-card-text>
                        {{ user.full_address }}<br>
                        {{ user.address_complement }}<br>
                        CEP: {{ user.cep }}
                      </b-card-text>
                    </b-list-group-item>
                    <b-list-group-item>
                      <b-card-text>
                        <b>Observações</b><br>
                        {{ user.observation }}
                      </b-card-text>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
                <!-- Card de Férias -->
                <b-card no-body>
                  <template v-slot:header>
                    <h4 class="mb-0 d-inline">Férias</h4>
                  </template>
                  <!-- Modo de display: acordeão com título sendo o período aquisitivo e as informações internas os dados daquele período.
                  Ex: 01-01023 - 01/01/2024
                  informações: scheduled_vacation_days, available_vacation_days, scheduled_vacation_periods.
                  Quando for adicionar férias, enviar o id do período aquisitivo no payload.
                  -->
                  <!-- Mostra quantos dias trabalhados, quantos dias de férias já teve e saldo de dias a fruir -->
                  <div v-if="user.acquisition_periods && (user.acquisition_periods).length > 0">
                    <div class="vacation-accordion" role="tablist" v-for="period in user.acquisition_periods">
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button class="" block style="background-color: transparent;" v-b-toggle="'accordion' + period.pk">{{ `${period.start_date} - ${period.end_date}`  }} <span style="float: right;"><span v-if="user.scheduled_vacation_days[period.pk]" title="Dias de férias programados" class="badge bg-info text-white rounded-circle d-inline-flex justify-content-center align-items-center" style="width: 22px; height: 22px; font-size: 14px; margin-left: 0.5rem">{{ user.scheduled_vacation_days[period.pk] }}</span> <span title="Dias disponíveis" class="badge bg-success text-white rounded-circle d-inline-flex justify-content-center align-items-center" style="width: 22px; height: 22px; font-size: 14px; margin-left: 0.5rem">{{ user.available_vacation_days[period.pk] }}</span></span></b-button>
                        </b-card-header>
                        <b-collapse :id="'accordion' + period.pk" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text>Quantidade de dias programados: {{ user.scheduled_vacation_days[`${period.pk}`] }}</b-card-text>
                            <b-card-text>Quantidade de dias disponíveis: {{ user.available_vacation_days[`${period.pk}`] }}</b-card-text>
                            <b-card-text><b>Períodos programados:</b></b-card-text>
                            <ul style="padding-left: 0">
                              <li style="list-style: none; padding-bottom: 0.50rem; border-bottom: 1px solid #80808040; margin-bottom: 1rem;" v-for="vacation in filteredVacationPeriods(period.pk)" :key="vacation.pk">
                                {{ vacation.start_date }} - {{ vacation.end_date }} - {{ vacation.days }} dias
                                
                                <!-- ações --->
                                <span class="span-is-link span-color-link float-right">
                                  <i class="fa fa-pencil-square-o" @click="updateVacation(vacation)"></i>
                                  <i class="fa fa-trash trash-color ml-3" @click="deleteVacation(vacation.pk)"></i>
                                </span>
                              </li>
                            </ul>
                            <span style="color: white; cursor: pointer; background-color: #4dbd74; padding: 0.375rem 0.75rem" @click="openVacationModal(period.pk)">
                              <i class="fa fa-plus"></i> Adicionar férias
                            </span>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                  <p v-else style="text-align: center; margin-top: 1rem">Férias não disponíveis para esse funcionário.</p>
                </b-card>
              </b-col>
              <b-col lg=4>
                <!-- Card Telefones -->
                <b-card no-body>
                  <template v-slot:header>
                    <h4 class="mb-0 d-inline">Telefones</h4>
                    <span class="span-is-link badge badge-success float-right" @click="openPhoneModal()">
                      <i class="fa fa-plus"></i> Adicionar
                    </span>
                  </template>
                  <b-list-group flush>
                    <b-list-group-item>
                      <table class="table table-responsive-sm table-outline">
                        <tbody>
                          <tr v-for="item in user.employee_phones" :key="item.pk">
                            <td>
                              <i class="fa fa-phone"></i><span class="lead"> {{ item.phone }}</span> <br>
                              <span>{{ item.phone_type_display }}</span>
                            </td>
                            <td class="p-1">
                              <span @click="openPhoneModal(item)">
                                <i v-if="canChangeCustomer" class="fa fa-pencil-square-o span-is-link span-color-link"></i>
                              </span>
                            </td>
                            <td class="p-1">
                              <span v-if="canDeleteCustomer" @click="deletePhone(item)">
                                <i class="fa fa-trash trash-color"></i>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
                <!-- Card Contatos -->
                <b-card no-body>
                  <template v-slot:header>
                    <h4 class="mb-o d-inline">Contatos</h4>
                    <span class="span-is-link badge badge-success float-right" @click="openContactModal()">
                      <i class="fa fa-plus"></i> Adicionar
                    </span>
                  </template>
                  <b-list-group flush>
                    <b-list-group-item>
                      <table class="table table-responsive-sm table-outline">
                        <tbody>
                          <tr v-for="item in user.employee_contacts" :key="item.pk">
                            <td>
                              <span class="lead">{{ item.name }}</span> <br>
                              <span v-if="item.relationship" class="text-muted">{{ item.relationship }} <br></span>
                              <b-link v-if="item.email" href="" class="card-link"><i class="fa fa-envelope-o"></i> {{ item.email }} <br></b-link>
                              <i class="fa fa-phone"></i> {{ item.phone }} <br>
                              <i v-if="item.phone2" class="fa fa-phone"></i> {{ item.phone2 }}
                            </td>
                            <td class="p-1">
                              <span @click="openContactModal(item)">
                                <i v-if="canChangeCustomer" class="fa fa-pencil-square-o span-is-link span-color-link"></i>
                              </span>
                            </td>
                            <td class="p-1">
                              <span v-if="canDeleteCustomer" @click="deleteContact(item)">
                                <i class="fa fa-trash trash-color"></i>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
                <!-- Card Online -->
                <b-card no-body v-if="user.online">
                  <template v-slot:header>
                    <h4 class="mb-o d-inline">Online</h4>
                  </template>
                  <b-list-group flush>
                    <b-list-group-item>
                      <b>LinkedIn:</b> <b-link :href="user.linkedin" target="_blank" class="card-link"> {{ user.linkedin }}</b-link>
                    </b-list-group-item>

                    <b-list-group-item>
                      <b>Função:</b> {{ user.occupation_online }}
                    </b-list-group-item>
                    <b-list-group-item>
                      <b>Occupation:</b> {{ user.occupation_online_en }}
                    </b-list-group-item>

                    <b-list-group-item>
                      <b>Descrição:</b> <br>
                      {{ user.description }}
                    </b-list-group-item>
                    <b-list-group-item>
                      <b>Description:</b> <br>
                      {{ user.description_en }}
                    </b-list-group-item>

                    <b-list-group-item>
                      <b>Atuação:</b> <br>
                      {{ user.actuation }}
                    </b-list-group-item>
                    <b-list-group-item>
                      <b>Actuation:</b> <br>
                      {{ user.actuation_en }}
                    </b-list-group-item>

                    <b-list-group-item>
                      <b>Idiomas:</b> {{ user.languages }}
                    </b-list-group-item>
                    <b-list-group-item>
                      <b>Languages:</b> {{ user.languages_en }}
                    </b-list-group-item>

                  </b-list-group>
                </b-card>
              </b-col>
              <b-col lg=4>
                <!-- Card dados bancários -->
                <b-card no-body v-if="$store.getters['auth/isAdmin']">
                  <template v-slot:header>
                    <h4 class="mb-o d-inline">Dados Bancários</h4>
                    <span class="span-is-link badge badge-success float-right" @click="openBankModal()">
                      <i class="fa fa-plus"></i> Adicionar
                    </span>
                  </template>
                  <b-list-group flush>
                    <b-list-group-item>
                      <table class="table table-responsive-sm table-outline">
                        <tbody>
                          <tr v-for="item in user.employee_bank_accounts" :key="item.pk">
                            <td width="70%">
                              <table class="table table-borderless">
                                <tbody>
                                  <tr>
                                    <td class="text-right">Nome do banco</td>
                                    <td>{{ item.name }}</td>
                                  </tr>
                                  <tr>
                                    <td class="text-right">Número do banco</td>
                                    <td>{{ item.bank }}</td>
                                  </tr>
                                  <tr>
                                    <td class="text-right">Agência</td>
                                    <td>{{ item.agency }}</td>
                                  </tr>
                                  <tr>
                                    <td class="text-right">Conta</td>
                                    <td>{{ item.account }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td class="p-1">
                              <span @click="openBankModal(item)">
                                <i class="fa fa-pencil-square-o span-is-link span-color-link"></i>
                              </span>
                            </td>
                            <td class="p-1">
                              <span @click="deleteBank(item)">
                                <i class="fa fa-trash trash-color"></i>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Modal Employee -->
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-modal :visible="isVisible" title="Editar Funcionário" @ok.prevent="passes(sendItem)" @hidden="clearModal" cancel-title="Cancelar" ok-title="Salvar" id="crm-modal">
        <div class="row">
          <div class="col-12" :class="$store.getters['auth/isAdmin'] ? 'col-md-6' : ''">
            <generic-form :fields="fields" :editing="editingItem"></generic-form>
          </div>
          <div class="col-12 col-md-6" v-if="$store.getters['auth/isAdmin']">
            <h3>Permissões</h3>
            <table class="table">
              <thead>
                <th></th>
                <th>Criar</th>
                <th>Ler</th>
                <th>Editar</th>
                <th>Deletar</th>
              </thead>
              <tr v-for="item in permissionSwitches" :key="item.slug">
                <td>{{ item.name }}</td>
                <td>
                  <c-switch class="mx-1" color="success" variant="pill" :checked="permission_codes.includes('add_' + item.slug)" @change="checkPermission($event, 'add_' + item.slug)" />
                </td>
                <td>
                  <c-switch class="mx-1" color="primary" variant="pill" :checked="permission_codes.includes('view_' + item.slug)" @change="checkPermission($event, 'view_' + item.slug)" />
                </td>
                <td>
                  <c-switch class="mx-1" color="warning" variant="pill" :checked="permission_codes.includes('change_' + item.slug)" @change="checkPermission($event, 'change_' + item.slug)" />
                </td>
                <td>
                  <c-switch class="mx-1" color="danger" variant="pill" :checked="permission_codes.includes('delete_' + item.slug)" @change="checkPermission($event, 'delete_' + item.slug)" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </b-modal>
    </ValidationObserver>
    <!-- Modal Phone -->
    <b-modal :visible="isPhoneVisible" :title="editingPhone.pk ? 'Editar Telefone' : 'Adicionar Telefone'" cancel-title="Cancelar" ok-title="Salvar" @ok="savePhone" @hidden="clearModal">
      <b-form-group label="Telefone" label-for="phone">
        <b-form-input id="phone" v-model="editingPhone.phone"></b-form-input>
      </b-form-group>
      <b-form-group label="Tipo" label-for="phone-type">
        <b-form-select id="phone-type" v-model="editingPhone.phone_type">
          <option v-for="phone in $store.state.phoneTypes" :value="phone.value">{{ phone.text }}</option>
        </b-form-select>
      </b-form-group>
    </b-modal>
    <!-- Modal Contact -->
    <b-modal :visible="isContactVisible" :title="editingContact.pk ? 'Editar Contato' : 'Adicionar Contato'" cancel-title="Cancelar" ok-title="Salvar" @ok="saveContact" @hidden="clearModal">
      <b-form-group label="Nome" label-for="editingContactName">
        <b-form-input id="editingContactName" v-model="editingContact.name"></b-form-input>
      </b-form-group>
      <b-form-group label="E-mail" label-for="editingContactEmail">
        <b-form-input id="editingContactEmail" type="email" v-model="editingContact.email"></b-form-input>
      </b-form-group>
      <b-form-group label="Telefone 1" label-for="editingContactPhone">
        <b-form-input id="editingContactPhone" v-model="editingContact.phone"></b-form-input>
      </b-form-group>
      <b-form-group label="Telefone 2" label-for="editingContactPhone2">
        <b-form-input id="editingContactPhone2" v-model="editingContact.phone2"></b-form-input>
      </b-form-group>
      <b-form-group label="Parentesco" label-for="editingContactRelationship">
        <b-form-input id="editingContactRelationship" v-model="editingContact.relationship"></b-form-input>
      </b-form-group>
    </b-modal>
    <!-- Modal Bank -->
    <b-modal :visible="isBankVisible" :title="editingBank.pk ? 'Editar Dados Bancários' : 'Adicionar Dados Bancários'" cancel-title="Cancelar" ok-title="Salvar" @ok="saveBank" @hidden="clearModal">
      <b-form-group label="Nome do banco" label-for="editingBankName">
        <b-form-input id="editingBankName" v-model="editingBank.name"></b-form-input>
      </b-form-group>
      <b-form-group label="Número do banco" label-for="editingBankBank">
        <b-form-input id="editingBankBank" v-model="editingBank.bank"></b-form-input>
      </b-form-group>
      <b-form-group label="Agência" label-for="editingBankAgency">
        <b-form-input id="editingBankAgency" v-model="editingBank.agency"></b-form-input>
      </b-form-group>
      <b-form-group label="Conta" label-for="editingBankAccount">
        <b-form-input id="editingBankAccount" v-model="editingBank.account"></b-form-input>
      </b-form-group>
    </b-modal>
    <!-- Modal Vacation -->
    <b-modal :visible="isVacationVisible" :title="editingVacation.pk ? 'Editar Férias' : 'Adicionar Férias'" no-close-on-backdrop cancel-title="Cancelar" @cancel="handleModalCancel" ok-title="Salvar" @ok="saveVacation">
      <b-form-group label="Data de início" label-for="editingVacationStartDate">
        <b-form-input id="editingVacationStartDate" type="date" v-model="editingVacation.start_date"></b-form-input>
      </b-form-group>
      <b-form-group label="Data de término" label-for="editingVacationEndDate">
        <b-form-input id="editingVacationEndDate" type="date" v-model="editingVacation.end_date"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-text style="font-size: 16px"> Quantidade de dias que serão programados: {{ editingVacation.vacation_days }} </b-form-text>
      </b-form-group>
      <!-- hidden input sending editingVacation.pk -->
      <input type="hidden" v-model="editingVacation.pk" value="user.pk">
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios';
import Vue from 'vue';
import states from '../../utils/states';

import GenericForm from '../../components/GenericForm';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  components: {
    GenericForm,
    cSwitch,
  },
  data() {
    return {
      componentKey: 0,
      occupations: [],
      user: {
        permissions: {
          permissions: []
        }
      },
      vacationToUpdatePk: null,
      openVacationDays: 0,
      editingItem: {
        active: true,
        first_name: '',
        last_name: '',
        email: '',
        personal_email: '',
        birthday: '',
        occupation_pk: '',
        photo: '',
        cpf: '',
        rg: '',
        cnh: '',
        oab: '',
        oab_uf: '',
        cep: '',
        address: '',
        address_number: '',
        complement: '',
        district: '',
        city: '',
        uf: '',
        date_admission: '',
        date_release: '',
        observation: '',
      },
      editingVacation: {
        pk: '',
        start_date: '',
        end_date: '',
        vacation_days: '',
      },
      editingPhone: {
        phone: '',
        phone_type: ''
      },
      editingContact: {
        name: '',
        email: '',
        phone: '',
        phone2: '',
        relationship: '',
      },
      editingBank: {
        name: '',
        bank: '',
        agency: '',
        account: '',
      },
      isVisible: false,
      isPhoneVisible: false,
      isContactVisible: false,
      isBankVisible: false,
      isVacationVisible: false,
      permissionSwitches: [{
        name: 'Cliente',
        slug: 'customer',
      }, {
        name: 'Financeiro',
        slug: 'expense',
      }, {
        name: 'Contrato',
        slug: 'contract',
      }, {
        name: 'TimeSheet',
        slug: 'timesheet',
      }, {
        name: 'Pastas',
        slug: 'folder',
      }],
      permission_codes: [],
      lockSwitches: false,
    }
  },
  created() {
    this.vacationToUpdatePk = null;

    this.$store.dispatch('loadDepartments');

    axios.get('/crm/occupations/')
      .then(response => {
        this.occupations = response.data.data;
      })

    const pk = this.$route.params.pk;
    const employee = this.$store.state.employees.items.find(e => e.pk == pk);

    if (employee) {
      this.user = employee;
      this.loadPhones();
      this.loadContacts();
      this.loadBanks();

      // breadcrumb
      this.$store.dispatch('setBreadcrumbs', [{
        name: 'Home',
      }, {
        name: 'Funcionários',
      }, {
        name: employee.name,
      }]);
      return;
    }

    if (this.$store.getters['auth/isAdmin']) {
      this.$store.dispatch('employees/loadPermissions');
    }

    axios.get('/crm/employees/' + pk + '/')
      .then(res => {
        this.user = res.data.data;
        this.loadPhones();
        this.loadContacts();
        this.loadBanks();

        // breadcrumb
        this.$store.dispatch('setBreadcrumbs', [{
          name: 'Home',
        }, {
          name: 'Funcionários',
        }, {
          name: this.user.name,
        }]);
        return;
      });
  },
  destroyed() {
    this.$store.dispatch('setBreadcrumbs', []);
  },
  computed: {
    occupation() {
      const occupation = this.occupations.find(o => o.value == this.user.occupation_pk);
      return occupation || {};
    },
    canAddContract() {
      return this.$store.state.auth.user.permission_codes.includes('add_contract')
    },
    canChangeContract() {
      return this.$store.state.auth.user.permission_codes.includes('change_contract')
    },
    canDeleteContract() {
      return this.$store.state.auth.user.permission_codes.includes('delete_contract')
    },
    canViewContract() {
      return this.$store.state.auth.user.permission_codes.includes('view_contract')
    },
    canAddCustomer() {
      return this.$store.state.auth.user.permission_codes.includes('add_customer')
    },
    canChangeCustomer() {
      return this.$store.state.auth.user.permission_codes.includes('change_customer')
    },
    canDeleteCustomer() {
      return this.$store.state.auth.user.permission_codes.includes('delete_customer')
    },
    canViewCustomer() {
      return this.$store.state.auth.user.permission_codes.includes('view_customer')
    },
    canAddExpense() {
      return this.$store.state.auth.user.permission_codes.includes('add_expense')
    },
    canChangeExpense() {
      return this.$store.state.auth.user.permission_codes.includes('change_expense')
    },
    canDeleteExpense() {
      return this.$store.state.auth.user.permission_codes.includes('delete_expense')
    },
    canViewExpense() {
      return this.$store.state.auth.user.permission_codes.includes('view_expense')
    },
    canAddFolder() {
      return this.$store.state.auth.user.permission_codes.includes('add_folder')
    },
    canChangeFolder() {
      return this.$store.state.auth.user.permission_codes.includes('change_folder')
    },
    canDeleteFolder() {
      return this.$store.state.auth.user.permission_codes.includes('delete_folder')
    },
    canViewFolder() {
      return this.$store.state.auth.user.permission_codes.includes('view_folder')
    },
    canAddTimesheet() {
      return this.$store.state.auth.user.permission_codes.includes('add_timesheet')
    },
    canChangeTimesheet() {
      return this.$store.state.auth.user.permission_codes.includes('change_timesheet')
    },
    canDeleteTimesheet() {
      return this.$store.state.auth.user.permission_codes.includes('delete_timesheet')
    },
    canViewTimesheet() {
      return this.$store.state.auth.user.permission_codes.includes('view_timesheet')
    },
    fields() {
      const fields = [{
          text: 'Ativo',
          name: 'active',
          type: 'checkbox'
        },
        {
          text: 'Online',
          name: 'online',
          type: 'checkbox'
        },
        {
          text: 'Nome',
          name: 'first_name',
          rules: 'required',
        },
        {
          text: 'Sobrenome',
          name: 'last_name',
        },
        {
          text: 'E-mail',
          name: 'email',
          type: 'email',
          rules: 'required|email',
        },
        {
          text: 'E-mail pessoal',
          name: 'personal_email',
        },
        {
          text: 'Nascimento',
          name: 'birthday',
          type: 'datepicker',
        },
        {
          text: 'Cargo',
          name: 'occupation_pk',
          options: this.occupations,
        },
        {
          text: 'Foto',
          name: 'photo',
          type: 'file',
        },
        {
          text: 'CPF',
          name: 'cpf',
          type: 'mask',
          mask: '###.###.###-##',
        },
        {
          text: 'RG',
          name: 'rg',
          type: 'mask',
          mask: '##.###.###-#',
        },
        {
          text: 'CNH',
          name: 'cnh',
        },
        {
          text: 'OAB',
          name: 'oab',
        },
        {
          text: 'OAB UF',
          name: 'oab_uf',
          options: states
        },
        {
          text: 'CEP',
          name: 'cep',
          type: 'cep',
        },
        {
          text: 'Endereço',
          name: 'address',
        },
        {
          text: 'Número',
          name: 'address_number',
        },
        {
          text: 'Complemento',
          name: 'complement',
        },
        {
          text: 'Bairro',
          name: 'district',
        },
        {
          text: 'Cidade',
          name: 'city',
        },
        {
          text: 'UF',
          name: 'uf',
          options: states
        },
        {
          text: 'Admissão',
          name: 'date_admission',
          type: 'datepicker',
        },
        {
          text: 'Saída',
          name: 'date_release',
          type: 'datepicker',
        },
        {
          text: 'Observações',
          name: 'observation',
          type: 'textarea'
        },
        {
          text: 'LinkedIn',
          name: 'linkedin'
        },
        {
          text: 'Ocupação',
          name: 'occupation_online'
        },
        {
          text: 'Occupation',
          name: 'occupation_online_en'
        },
        {
          text: 'Descrição',
          name: 'description',
          type: 'textarea'
        },
        {
          text: 'Description',
          name: 'description_en',
          type: 'textarea'
        },
        {
          text: 'Atuação',
          name: 'actuation',
          type: 'textarea'
        },
        {
          text: 'Actuation',
          name: 'actuation_en',
          type: 'textarea'
        },
        {
          text: 'Idiomas',
          name: 'languages'
        },
        {
          text: 'Languages',
          name: 'languages_en'
        },
      ];

      return fields;
    }
  },
  methods: {
    updateEmployeeVacationData() {
      axios.get('/crm/employees/' + this.user.pk + '/')
      .then(res => {
        this.user.scheduled_vacation_days = res.data.data.scheduled_vacation_days;
        this.user.available_vacation_days = res.data.data.available_vacation_days;
      });
    },
    handleModalCancel() {
      this.clearModal();
    },  
    filteredVacationPeriods(period_pk) {
      return this.user.scheduled_vacation_periods.filter(
        period => period.acquisition_period_pk === period_pk
      );
    },
    calculateVacationDays() {
      const startDate = new Date(this.editingVacation.start_date);
      const endDate = new Date(this.editingVacation.end_date);

      if (!this.editingVacation.start_date || !this.editingVacation.end_date) {
        return '';
      }

      const timeDifference = endDate.getTime() - startDate.getTime();
      const daysDifference = (Math.ceil(timeDifference / (1000 * 3600 * 24))) + 1;

      this.editingVacation.vacation_days = daysDifference > 0 ? daysDifference : 0;
    },
    loadPhones() {
      axios.get('/crm/employees/phone/' + this.user.pk + '/')
        .then(response => {
          Vue.set(this.user, 'employee_phones', response.data.data);
        });
    },
    loadContacts() {
      axios.get('/crm/employees/contact/' + this.user.pk + '/')
        .then(response => {
          Vue.set(this.user, 'employee_contacts', response.data.data);
        });
    },
    loadBanks() {
      axios.get('/crm/employees/bank/' + this.user.pk + '/')
        .then(response => {
          Vue.set(this.user, 'employee_bank_accounts', response.data.data);
        });
    },
    editItem() {
      this.lockSwitches = true;
      this.permission_codes = this.user ? [...this.user.permission_codes] : [];

      setTimeout(() => {
        this.lockSwitches = false;
      }, 1000);

      this.isVisible = true;

      this.editingItem = { ...this.user };
    },
    openPhoneModal(item) {
      if (item) {
        this.editingPhone = { ...item };
        this.$store.dispatch('loadPhoneTypes');
      }
      this.$store.dispatch('loadPhoneTypes');
      this.isPhoneVisible = true;
    },
    openContactModal(item) {
      if (item) {
        this.editingContact = { ...item };
      }

      this.isContactVisible = true;
    },
    openVacationModal(period_pk) {
      this.isVacationVisible = true;
      if (period_pk) {
        this.acquisitionPeriodToAddVacation = period_pk
      }
    },
    openBankModal(item) {
      if (item) {
        this.editingBank = { ...item };
      }

      this.isBankVisible = true;
    },
    async sendItem() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }

      this.editingItem.permission_codes = this.permission_codes;

      this.$store.dispatch('employees/editItem', this.editingItem)
      this.user = {
        ...this.editingItem,
        name: this.editingItem.first_name + ' ' + this.editingItem.last_name,
      }
      this.clearModal()
    },
    // Métodos de férias
    saveVacation() {
      if (this.vacationToUpdatePk) {
        this.$swal.fire({
        title: 'Editar férias',
        text: 'Deseja realmente prosseguir com essa edição?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.value) {
            this.editVacation()
          }
        });
        
      } else {
        this.$swal.fire({
        title: 'Adicionar férias',
        text: 'Deseja realmente adicionar essas férias?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.value) {
            const pk = this.$route.params.pk;
            this.editingVacation.employee_pk = pk
            this.editingVacation.acquisition_period_pk = this.acquisitionPeriodToAddVacation
            try {
              this.$store.dispatch('employees/addVacation', this.editingVacation)
              .then((response) => {
                if (response.status == 200) {
                  this.clearModal()
                  this.$swal('Férias Programadas', 'Férias programadas com sucesso.', 'success');
                  // Adiciona o período de férias à lista de períodos programados do funcionário
                  this.user.scheduled_vacation_periods.unshift(response.vacation_info)
                  this.updateEmployeeVacationData()
                }
                else if (response.error) {
                  this.$swal('Erro ao Criar Férias', response.error, 'error');
                } else {
                  this.$swal('Erro ao Criar Férias', 'Tente novamente. Se o problema persistir, fale com o suporte.', 'error');
                }
              });
            } catch (error) {
              this.$swal('Erro ao Criar Férias', 'Tente novamente. Se o problema persistir, fale com o suporte.', 'error');
            }
          }
        });
        
      }
    },
    async editVacation() {
        try {
          this.editingVacation.vacationPk = this.vacationToUpdatePk
          await this.$store.dispatch('employees/updateVacation', this.editingVacation)
          .then((response) => {
            if (response.status == 200) {
              this.clearModal()
              this.$swal('Férias Atualizadas', 'Férias atualizadas com sucesso.', 'success')
              this.updateEmployeeVacationData()
            }
            else if (response.error) {
              this.$swal('Erro ao Atualizar Férias', response.error, 'error')
            } else {
              this.$swal('Erro ao Atualizar Férias', 'Tente novamente. Se o problema persistir, fale com o suporte.', 'error')
            }
          });
        } catch (error) {
          this.$swal('Erro ao Atualizar Férias', 'Tente novamente. Se o problema persistir, fale com o suporte.', 'error')
        }
    },
    updateVacation(vacation) {
      this.vacationToUpdatePk = vacation.pk
      this.editingVacation.start_date = vacation.start_date;
      this.editingVacation.end_date = vacation.end_date;
      this.editingVacation.vacation_days = vacation.days;
      this.openVacationModal()
    },
    deleteVacation(vacationPk) {
      this.$swal.fire({
        title: 'Deletar férias',
        text: 'Deseja realmente deletar esse período de férias?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.value) {
            try {
              this.$store.dispatch('employees/deleteVacation', vacationPk)
              .then((response) => {
                if (response.status == 200) {
                  this.clearModal()
                  const vacationToDelete = response.vacation_info.pk

                  // Procura o index das férias no array de férias programadas do funcionário
                  let vacationIndex = this.user.scheduled_vacation_periods.findIndex(item => item.pk === vacationToDelete);
                  if (vacationIndex !== -1) {
                    this.user.scheduled_vacation_periods.splice(vacationIndex, 1);
                  }

                  this.$swal('Férias Deletadas', 'Férias deletadas com sucesso.', 'success')
                  this.updateEmployeeVacationData()
                }
                else if (response.error) {
                  this.$swal('Erro ao Deletar Férias', response.error, 'error')
                } else {
                  this.$swal('Erro ao Deletar Férias', 'Tente novamente. Se o problema persistir, fale com o suporte.', 'error')
                }
              });
            } catch (error) {
              this.$swal('Erro ao Deletar Férias', 'Tente novamente. Se o problema persistir, fale com o suporte.', 'error')
            }
          }
      });
    },
    //
    savePhone() {
      const pk = this.$route.params.pk;
      let bodyFormData = new FormData();

      Object.keys(this.editingPhone).forEach(i => bodyFormData.append(i, this.editingPhone[i]))

      if (this.editingPhone.pk) {
        axios.post('/crm/employees/phone/' + this.editingPhone.pk + '/edit/', bodyFormData)
          .then(response => {
            const index = this.user.employee_phones.findIndex(c => c.pk == this.editingPhone.pk);

            const phones = this.user.employee_phones;
            Vue.set(phones, index, response.data.data);
            Vue.set(this.user, 'employee_phones', phones);

            this.$forceUpdate();
          });
      } else {
        axios.post('/crm/employees/phone/' + pk + '/add/', bodyFormData)
          .then(response => {
            this.user.employee_phones.push(response.data.data);
          });
      }
    },
    saveContact() {
      const pk = this.$route.params.pk;
      let bodyFormData = new FormData();

      Object.keys(this.editingContact).forEach(i => bodyFormData.append(i, this.editingContact[i]))

      if (this.editingContact.pk) {
        axios.post('/crm/employees/contact/' + this.editingContact.pk + '/edit/', bodyFormData)
          .then(response => {
            const index = this.user.employee_contacts.findIndex(c => c.pk == this.editingContact.pk);

            const contacts = this.user.employee_contacts;

            Vue.set(contacts, index, response.data.data);
            Vue.set(this.user, 'employee_contacts', contacts);

            this.$forceUpdate();
          });
      } else {
        axios.post('/crm/employees/contact/' + pk + '/add/', bodyFormData)
          .then(response => {
            this.user.employee_contacts.push(response.data.data);
          });
      }
    },
    saveBank() {
      const pk = this.$route.params.pk;
      let bodyFormData = new FormData();

      Object.keys(this.editingBank).forEach(i => bodyFormData.append(i, this.editingBank[i]))

      if (this.editingBank.pk) {
        axios.post('/crm/employees/bank/' + this.editingBank.pk + '/edit/', bodyFormData)
          .then(response => {
            const index = this.user.employee_bank_accounts.findIndex(c => c.pk == this.editingBank.pk);
            Vue.set(this.user.employee_bank_accounts, index, response.data.data);
          });
      } else {
        axios.post('/crm/employees/bank/' + pk + '/add/', bodyFormData)
          .then(response => {
            this.user.employee_bank_accounts.push(response.data.data);
          });
      }
    },
    deleteItem() {
      const pk = this.$route.params.pk;
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          axios.post('/crm/employees/' + pk + '/delete/')
            .then(response => {
              window.location.href = '/app/crm/employees/'
            });
        }
      });
    },
    deleteContact(item) {
      this.editingContact = item;
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          axios.post('/crm/employees/contact/' + this.editingContact.pk + '/delete/')
            .then(response => {
              const index = this.user.employee_contacts.findIndex(c => c.pk == this.editingContact.pk);
              this.user.employee_contacts.splice(index, 1)
              this.clearModal();
            });
        }
      });
    },
    deletePhone(item) {
      this.editingPhone = item;
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          axios.post('/crm/employees/phone/' + this.editingPhone.pk + '/delete/')
            .then(response => {
              const index = this.user.employee_phones.findIndex(c => c.pk == this.editingPhone.pk);
              this.user.employee_phones.splice(index, 1)
              this.clearModal();
            });
        }
      });
    },
    deleteBank(item) {
      this.editingBank = item;
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          axios.post('/crm/employees/bank/' + this.editingBank.pk + '/delete/')
            .then(response => {
              const index = this.user.employee_bank_accounts.findIndex(c => c.pk == this.editingBank.pk);
              this.user.employee_bank_accounts.splice(index, 1)
              this.clearModal();
            });
        }
      });
    },
    clearModal() {
      this.isVisible = false;
      this.editingPhone = {
        phone: '',
        type: ''
      };
      this.isPhoneVisible = false;
      this.editingContact = {
        name: '',
        email: '',
        phone1: '',
        phone2: '',
      };
      this.isContactVisible = false;
      this.editingBank = {
        name: '',
        bank: '',
        agency: '',
        account: '',
      }
      this.isBankVisible = false;
      this.isVacationVisible = false;
      this.editingVacation = {
        start_date: '',
        end_date: '',
        vacation_days: '',
        acquisition_period_pk: ''
      }

    },
    checkPermission(item, code) {
      if (this.lockSwitches) {
        return;
      }

      if (!this.permission_codes.includes(code)) {
        this.permission_codes.push(code);
      } else {
        this.permission_codes.splice(this.permission_codes.indexOf(code), 1);
      }

      this.$store.dispatch('employees/updatePermissions', {
          pk: this.editingItem.pk,
          permissionCodes: this.permission_codes,
        })
        .then(() => {
          Vue.set(this.user, 'permission_codes', this.permission_codes);
        });
    },
  },
  watch: {
    'editingVacation.start_date': 'calculateVacationDays',
    'editingVacation.end_date': 'calculateVacationDays',
  }
}

</script>
<style>
.vacation-accordion {
  background-color: none;
  border: gray;
}

.btn-secondary {
  background-color: transparent !important;
  color: #23282c !important;
}

#crm-modal .modal-dialog {
  max-width: 70% !important;
}

.table-perm {
  width: 100%;
  font-size: 10px;
}

.table-perm .row {
  width: 100%;
  margin: 0 auto;
  padding: 3px;
}

.table-perm .col-4 {
  background-color: #fff;
  text-align: center;
  padding: 0px;
}

.table-perm .col-4 .crud {
  padding: 5px;
  border: 1px solid #c8ced3;
}

.table-perm .col-4 .text-center {
  border: 1px solid #c8ced3;
}

.l-spacing {
  letter-spacing: 3px;
}

.p-right {
  padding-right: 2px;
}

</style>
